import { _axios } from "../../../Utils/Axios/axios";

export const getFullQuizDataService = async (userToken: string) => {
  return _axios.post(
    "/complete_quiz",
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
